import {
  FundingPolicyTypeDef,
  fundingPolicyTypeDefList,
  fundingPolicyTypeDefs,
  isNullOrUndefined,
} from '@shared';
import { orderBy } from 'lodash';

export function getApplicablePolicyTypes(client: Client, featureFlags: FeatureFlags) {
  const { mutableClientPartner } = client;
  const applicablePolicyTypes = fundingPolicyTypeDefList
    .filter(policyTypeDef => passesFeatureFlagChecks(policyTypeDef, featureFlags))
    .filter(policyTypeDef => canShowJointPolicies(policyTypeDef, mutableClientPartner));

  return orderBy(applicablePolicyTypes, 'listPriority');
}

// Check if the client has a joint policy. For now, we don't allow multiple joint policies
// until we can copy the exact policy to the partner client
export function checkIfHasJointPolicy(multipleFundingSources: MultipleFundingSources): boolean {
  return Object.values(multipleFundingSources.ltcPolicy).some(
    policy => policy.policyType && fundingPolicyTypeDefs[policy.policyType].isJoint,
  );
}

// Filter joint policy if no partner
function canShowJointPolicies(
  policyTypeDef: FundingPolicyTypeDef,
  mutableClientPartner: Client | null,
): boolean {
  const canShowIfJoint = !isNullOrUndefined(mutableClientPartner) || !policyTypeDef.isJoint; // Client must have a partner to show joint policies
  return canShowIfJoint;
}

// Apply feature flag-based filtering
function passesFeatureFlagChecks(
  policyTypeDef: FundingPolicyTypeDef,
  featureFlags: FeatureFlags,
): boolean {
  // only show group policies if the feature flag is enabled
  if (policyTypeDef.isGroupPolicy && !featureFlags?.vbShop && !featureFlags?.agis) {
    return false;
  }
  return true;
}
